import { render, staticRenderFns } from "./paramsInterfaceForm.vue?vue&type=template&id=44a0064c&scoped=true&"
import script from "./paramsInterfaceForm.vue?vue&type=script&lang=js&"
export * from "./paramsInterfaceForm.vue?vue&type=script&lang=js&"
import style0 from "./paramsInterfaceForm.vue?vue&type=style&index=0&id=44a0064c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a0064c",
  null
  
)

export default component.exports